(() => {
  function initProof(section) {
    if (section.dataset.proofPolishReady || !window.Swiper) return;
    const stage = section.querySelector('.valora-pdp-proof-stage');
    if (!stage) return;
    section.dataset.proofPolishReady = 'true';
    const tabs = Array.from(section.querySelectorAll('[data-proof-tab]'));
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const syncTabs = (swiper) => {
      tabs.forEach((tab, index) => {
        const active = index === swiper.realIndex;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });
    };
    const slider = new window.Swiper(stage, {
      slidesPerView:1.1,
      spaceBetween:15,
      loop:true,
      speed:reduced ? 0 : 600,
      centeredSlides:true,
      navigation:{ nextEl:section.querySelector('[data-proof-next]'), prevEl:section.querySelector('[data-proof-prev]') },
      pagination:{ el:section.querySelector('[data-proof-count]'), clickable:true },
      a11y:{ enabled:true },
      keyboard:{ enabled:true, onlyInViewport:true },
      breakpoints:{ 768:{ slidesPerView:3, spaceBetween:20 }, 1024:{ slidesPerView:3, spaceBetween:21, centeredSlides:true } },
      on:{ init:syncTabs, slideChange:syncTabs }
    });
    tabs.forEach((tab, index) => tab.addEventListener('click', () => slider.slideToLoop(index, reduced ? 0 : 600)));
    section.addEventListener('shopify:section:unload', () => slider.destroy(true,true), { once:true });
  }
  function initMore(section) {
    const button = section.querySelector('[data-review-more]');
    const extra = section.querySelector('[data-review-extra]');
    if (!button || !extra || button.dataset.ready) return;
    button.dataset.ready = 'true';
    button.addEventListener('click', () => {
      extra.hidden = false;
      extra.classList.add('is-revealed');
      button.setAttribute('aria-expanded','true');
      button.hidden = true;
    });
  }
  function init() {
    document.querySelectorAll('[data-proof-polish]').forEach(initProof);
    document.querySelectorAll('.valora-pdp-reviews').forEach(initMore);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
})();
